<div class="dialog-title mat-tab-label-active text-muted px-3">
  <div>{{ "new-order" | translate }}</div>
  <div>
    <button cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle cdkDragBoundary=".cdk-overlay-container"
      mat-icon-button class="drag-handler text-center" style="cursor: grab">
      <mat-icon style="font-size: 18px">open_with</mat-icon>
    </button>
    <button mat-icon-button class="text-center" mat-dialog-close>
      <mat-icon style="font-size: 18px">close</mat-icon>
    </button>
  </div>
</div>
<!-- <div *ngIf="((isBuyLoading&& initqty==null) || (isLoading && initqty!=null))" class="d-flex justify-content-center align-items-center loading-container">
  <span class="spinner-border loading-spinner"></span>
</div> -->
<div class="tab-container">
  <mat-tab-group mat-stretch-tabs class="p-0"
  *ngIf="company "
  (selectedTabChange)="onTabChanged($event)" [(selectedIndex)]="tabIndex"
   [ngClass]="{ 'isSell': tabIndex == 1, 'isBuy': tabIndex == 0 }">
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="buy">{{ "buy" | translate }}</span>
    </ng-template>
    <div class="d-flex justify-content-between" id="dark" >
      <div class="market-trade-buy text-color-theme">
        <div class="row mb-2">
          <div class="col-12">
        <!-- // This is the part for test desigen for copmpany  -->
        <div class="container" *ngIf="!companyDetails">
          <div class="row" style="text-align: center;">
            <div class="col-md-12 mb-3" >
              <span class="text-muted" >
                <label > <br />
                  {{ "choose-company" | translate }}</label>
                  <i class="fa-solid fa-search mx-1 font-medium text-highlight-company-color clickable" (click)="selectCompany()" style="font-family: 'Font Awesome 6 Free' !important;"></i>
                </span>

            </div>
          </div>
              </div>
            <div class="stock-card" *ngIf="companyDetails">
                <div class="stock-left">
                    <img [src]="UrlImage" alt="Stock Image for {{ company.SYMBOL_CODE }}" class="stock-logo">
                    <i class="fa-solid fa-marker mx-1 font-medium text-highlight-company-color clickable " (click)="selectCompany()" style="font-family: 'Font Awesome 6 Free' !important;" ></i>
                    <div class="stock-info">
                        <div class="stock-title  text-start">{{company.Reuters}}            
                          <span *ngIf="company?.SYMBOL_STATE == 'S'" class="badge bg-danger text-light mx-1">
                          {{ "company-suspended" | translate }}
                        </span></div> 
                        <div class="stock-subtitle text-start ">{{translate.currentLang == "en" ? company.ENG_NAME : company.ARB_NAME}}</div>
                    </div>
                </div>
                <div class="stock-right">
                    <div [ngClass]="{
                      'pulse': company.LAST_TRADE_PRICE_UPDATED === 2,
                      'pulse-up': company.LAST_TRADE_PRICE_UPDATED === 1,
                      'no-change': company.LAST_TRADE_PRICE_UPDATED === 0
                    }"
                     class="stock-price" >{{company.LAST_TRADE_PRICE | number : "1.0" : "en-US"}} <span class="currency">{{
                        company.CURRENCY == 1 
                          ? (translate.currentLang === 'en' ? 'EGP' : 'جنيه مصرى')
                          : company.CURRENCY == 2 
                          ? (translate.currentLang === 'en' ? 'USD' : 'دولار امريكى')
                          : ''
                      }}</span></div>
                    <div [ngClass]="{
                      'pulse': company.LAST_CHANGE_PRC_UPDATED === 2,
                      'pulse-up': company.LAST_CHANGE_PRC_UPDATED === 1,
                      'no-change': company.LAST_CHANGE_PRC_UPDATED === 0,
                      'green':company.LAST_CHANGE_PRC > 0,
                      'red':company.LAST_CHANGE_PRC < 0
                    }" 
                     [ngClass]="company.LAST_CHANGE_PRC > 0 ? 'green' : 'red'"  class="stock-change">{{ company.LAST_CHANGE | number : "1.0" : "en-US" }} ({{company.LAST_CHANGE_PRC | number : "1.0" : "en-US"}}%) <span *ngIf="company.LAST_CHANGE_PRC <= 0" class="arrow">&#8595;</span> <span *ngIf="company.LAST_CHANGE_PRC > 0" class="arrow">&#8593;</span></div>
                </div>
            </div>


        <!-- // This is the part is end  test desigen for copmpany  -->
          </div>
        </div>
        <div class="ticket-buy" *ngIf="companyDetails">
          <div class="ticket-content">
            <div class="row">
              <div class="column">
                <div class="label">{{ "best-bid" | translate }} </div>
                <div class="value" >         
                  <span class="scalable"
                  [ngClass]="{
                    'pulse': company.BID_PRICE_UPDATED === 2,
                    'pulse-up': company.BID_PRICE_UPDATED === 1,
                    'no-change': company.BID_PRICE_UPDATED === 0
                  }">{{ company.BID_PRICE | number : "1.0" : "en-US" }}</span> /
                  <span class="scalable"
                  [ngClass]="{
                    'pulse': company.BID_VOLUME_UPDATED === 2,
                    'pulse-up': company.BID_VOLUME_UPDATED === 1,
                    'no-change': company.BID_VOLUME_UPDATED === 0
                  }">{{ company.BID_VOLUME | number : "1.0" : "en-US" }}</span></div>
              </div>
              <div class="column">
                <div class="label"> {{ "best-ask" | translate }}</div>
                <div class="value" >            
                  <span class="scalable"
                  [ngClass]="{
                    'pulse': company.ASK_PRICE_UPDATED === 2,
                    'pulse-up': company.ASK_PRICE_UPDATED === 1,
                    'no-change': company.ASK_PRICE_UPDATED === 0
                  }">{{ company.ASK_PRICE | number : "1.0" : "en-US" }}</span> /
                  <span class="scalable"
                  [ngClass]="{
                    'pulse': company.ASK_VOLUME_UPDATED === 2,
                    'pulse-up': company.ASK_VOLUME_UPDATED === 1,
                    'no-change': company.ASK_VOLUME_UPDATED === 0
                  }">{{ company.ASK_VOLUME | number : "1.0" : "en-US" }}</span></div>
              </div>
              <div class="column">
                <div class="d-flex flex-column align-items-center">
                  <!-- First Row: Text & Hint Popover (Side by Side) -->
                  <div class="d-flex align-items-center">
                    <span class="me-2">           
                    {{ "Margin"|translate }}
                    </span>
              
                    <hint-popover *ngIf="companyDetails?.ISMarginable != null && companyDetails?.ISMarginable != false"
                      [key]="'ISMarginable'" [value]="companyDetails?.MarginPercentage" [placement]="translate.currentLang == 'ar' ? 'right' : 'left'"></hint-popover>
                    <hint-popover *ngIf="companyDetails?.ISMarginable == null || companyDetails?.ISMarginable == false"
                      [key]="'ISNotMarginable'" [placement]="translate.currentLang == 'ar' ? 'right' : 'left'"></hint-popover>
      
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="ms-2">
                      <path
                        d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                    </svg>
                  </div>
                  <!-- IsMargin with Green Check -->
                  <div *ngIf="(companyDetails?.ISMarginable != null && companyDetails?.ISMarginable != false) && (isCustodianSymbolMarginAvailable || !inputUser?.IsMargin)"
                    class="d-flex align-items-center me-2">
                    <span class="check-mark-icon">
                      <svg class="svg-green"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path
                          d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z">
                        </path>
                      </svg>
                    </span>
                  </div>
      
                  <!-- IsMargin with Red Cross -->
                  <div *ngIf="(companyDetails?.ISMarginable == null || companyDetails?.ISMarginable == false) || (!isCustodianSymbolMarginAvailable && inputUser?.IsMargin && companyDetails?.ISMarginable)"
                    class="d-flex align-items-center me-2">
                    <span class="check-mark-icon">
                      <svg class="svg-red" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path
                          d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z">
                        </path>
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
              
            </div>
        
            <hr class="divider" />
        
            <div class="row">
              <div class="column">
                <p class="label"> {{ "max-limit" | translate }} </p>
                <p class="value">{{ companyDetails?.MaxLimit }}</p>
              </div>
              <div class="column">
                <p class="label">{{ "min-limit" | translate }}</p>
                <p class="value"> {{ companyDetails?.MinLimit }}</p>
              </div>
              <div class="column">
                <div class="d-flex flex-column align-items-center">
                    <!-- First Row: Text & Hint Popover (Side by Side) -->
                    <div class="d-flex align-items-center">
                      <span class="me-2">{{ "T+0 " }}</span>
                
                      <hint-popover *ngIf="companyDetails?.SameDayQty != null && companyDetails?.SameDayQty != 0"
                        [key]="'T0-enabled'" [placement]="translate.currentLang == 'ar' ? 'bottom' : 'bottom'">
                      </hint-popover>
                
                      <hint-popover *ngIf="companyDetails?.SameDayQty == null || companyDetails?.SameDayQty == 0"
                        [key]="'T0-disabled'" [placement]="translate.currentLang == 'ar' ? 'bottom' : 'bottom'">
                      </hint-popover>
                    </div>
                
                    <!-- Second Row: Check Mark -->
                    <div class="d-flex justify-content-center">
                      <span class="check-mark-icon">
                        <svg *ngIf="companyDetails?.SameDayQty != null && companyDetails?.SameDayQty != 0" class="svg-green"
                          xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                          <path
                            d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z">
                          </path>
                        </svg>
                
                        <svg *ngIf="companyDetails?.SameDayQty == null || companyDetails?.SameDayQty == 0" class="svg-red"
                          xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                          <path
                            d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z">
                          </path>
                        </svg>
                      </span>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <hr style="background: #6c757d !important; margin: 5px;" />
        <form [formGroup]="orderForm">
          <div class="form-group">
            <div class="row">
              <div class="col-md-12" style="margin-bottom: 1vh !important;">
                <h6 class="text-start text-color-theme">
                  {{ "select-account" | translate }}
                </h6>
                <div class="col-10 p-0">
                  <ng-select class="custom" appearance="outline" [clearable]="false" (change)="onSelectClient($event)" [searchable]="false" formControlName="client">
                    <ng-option *ngFor="let acc of accList" value="{{acc.relationCode}}">
                      ({{acc.relationCode}}) {{translate.currentLang=='en'?acc.clientNameEn:acc.clientNameAr}}
                    </ng-option>
                  </ng-select>
                  <div *ngIf="f.client.touched && f.client.invalid" class="red">
                    <div *ngIf="f.client.errors?.required">You must select client</div>
                  </div>

                </div>
                <user-selection *ngIf="tabIndex == 0" [inputUser]="inputUser" [isBindValue]="true"
                  (userChanged)="onSelectClient($event)"></user-selection>
                <section *ngIf="isFetchingUserData">
                  <mat-progress-bar class="example-margin" [color]="'primary'" [mode]="'indeterminate'" [value]="50"
                    [bufferValue]="75">
                  </mat-progress-bar>
                </section>

                <div *ngIf="f.client.touched && f.client.invalid" class="red">
                  <div *ngIf="f.client.errors?.required">
                    You must select client
                  </div>
                </div>
              </div>

            </div>

           
            <ngb-alert class="margin-alert" [dismissible]="false" *ngIf="
                this.inputUser &&
                this.inputUser.IsMargin &&
                investmentData != null &&
                investmentData.isCheckInvestmentAmount
              "
              [ngStyle]="{'text-align': translate.currentLang == 'ar' ? 'right' : 'left'}">

              {{
              translate.currentLang == "en"
              ? " Collateral: " +
             (inputUser?.accountType === 2 
                  ? (this.custodianSymbolSpecificMarginPercentage!=-1 ? this.custodianSymbolSpecificMarginPercentage + "%" : translate.instant('margin-not-available-custodian'))
                  : (companyDetails?.MarginPercentage != null ? companyDetails.MarginPercentage + "%" : translate.instant('margin-not-available-custodian'))) +
              "\n" +
              "Max. allowed amount: " +
              investmentData.investmentAmount +
              (company.CURRENCY == 1 ? "EGP" : "USD") +
              "\n"+
              "Current Weight: " +
              investmentData.currentWeight +
              "%, Max Weight: " +
              investmentData.targetWeight * 100 +
              "%"
              :" ضمانه السهم: " +
            (inputUser?.accountType === 2 
                  ? (this.custodianSymbolSpecificMarginPercentage!=-1 ? this.custodianSymbolSpecificMarginPercentage + "%" : translate.instant('margin-not-available-custodian'))
                  : (companyDetails?.MarginPercentage != null ? companyDetails.MarginPercentage + "%" : translate.instant('margin-not-available-custodian'))) +
              "\n" +
              "اقصي قيمة للتمويل: " +
              investmentData.investmentAmount +
              (company.CURRENCY == 1 ? " جم " : " دولار ") +
              "\n"+
              "اقصي
              وزن مسموح: " +
              investmentData?.targetWeight * 100 +
              "% " +
              " الوزن الحالى: " +
              investmentData?.currentWeight +
              "%" +
              "\n"




              }}

              <span *ngIf="investmentData?.targetWeight * 100 < investmentData?.currentWeight"
                style="margin-right: 35%; font-size: 19px; color: red; font-weight: 800;">
                {{translate.currentLang == "en"
                ? "\n" +"Financing not allowed":"لا يمكن التمويل"}}
              </span>
              <i class="ion-md-warning" [ngClass]="
                  translate.currentLang == 'en'
                    ? 'warn-icon-ltr'
                    : 'warn-icon-rtl'
                "></i>
            </ngb-alert>
            <ngb-alert       [ngStyle]="{'text-align': translate.currentLang == 'ar' ? 'right' : 'left'}" class="margin-alert" [dismissible]="false" [ngClass]="{ hidden: marketDisbaled }">
              {{
              translate.currentLang == "en"
              ? "You cannot buy this stock using market price!"
              :"لا يمكنك شراء هذا السهم بسعر السوق!"
              }}
              <i class="ion-md-warning warn-icon-single" [ngClass]="  
                "></i>
            </ngb-alert>
            <div class="openOrderRestriction-text" [ngClass]="{'hidden': !userProfile?.OpenOrderRestriction}">
              {{
                "openOrdersDisabled" | translate
                }}
            </div>
        <!-- // This is the part for Price type  -->
        <div class="col-md-12">
          <mat-button-toggle-group (change)="toggle($event)" class="toggle-group-border"
            style="width: 100%; border-radius: 40px" appearance="legacy" value="limit">
            <mat-button-toggle style="width: 50%" [ngClass]="{ noHover: !marketDisbaled }" value="limit">{{
              "limit-price" | translate
              }}</mat-button-toggle>
            <mat-button-toggle style="width: 50%" value="market" [ngClass]="{ disabled: !marketDisbaled }">{{
              "market-price" | translate
              }}</mat-button-toggle>
          </mat-button-toggle-group>
        </div>

        
        <!-- // This is the part is end Price type   -->


            <div class="row mt-4 mb-2">
              <div class="col-md-6">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="border-radius: 5px">{{
                      "qty" | translate
                      }}</span>
                  </div>
                  <input style="border-radius: 5px; letter-spacing: 1px"
                    oninput="if(!this.value.match('^[1-9][0-9]*$'))this.value='';" (keypress)="numberOnly($event)"
                    formControlName="qty" type="text" class="form-control" [ngClass]="
                      translate.currentLang == 'en'
                        ? 'number-input'
                        : 'number-input-ar'
                    " />
                  <!-- <div class="input-group-append">
                  <span class="input-group-text">Share</span>
                </div> -->
                </div>
              </div>

              <div class="col-md-6" [ngClass]="{ hidden: isMarket }">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="border-radius: 5px">
                      {{ "price" | translate }}
                    </span>
                  </div>
                  <input style="border-radius: 5px; text-align: center" min="1" (keypress)="priceDecimalInput($event)"
                    formControlName="price" type="text" class="form-control" [ngClass]="
                      translate.currentLang == 'en' ? 'number-input' : 'number-input-ar'
                    " />
                </div>
              </div>
              <div class="col-md-6" [ngClass]="{ hidden: !isMarket }">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="border-radius: 5px">
                      {{ "price" | translate }}
                    </span>
                  </div>
                  <input style="border-radius: 5px; text-align: center" min="1" disabled="true" placeholder="MKT"
                    type="text" class="form-control" [ngClass]="
                      translate.currentLang == 'en' ? 'number-input' : 'number-input-ar'
                     
                    " />
                </div>
              </div>

            </div>

        <!-- // This is the part of Order Data   -->
              <div class="container" *ngIf="!clientData">
          <div class="row" style="text-align: center;">
            <div class="col-md-12 mb-3" >
              <span class="text-muted" >
                <label > <br />
                  {{ "select-account" | translate }}</label>
              </span>

            </div>
          </div>
              </div>
              <div class="container" *ngIf="clientData">
                <div class="row">
                  <div class="col-md-6 mb-1 px-1"
                    [@expandCard]="purchasePowerState"
                    class="purchase-power-card px-1 col-md-6">
                    <div class="data-card">
                      <div class="data-title">
                        {{ "purchase-power" | translate }}
                      </div>
                      <div class="data-value">
                        <span *ngIf="company.CURRENCY == 1 && clientData"
                          [ngClass]="clientData.purchasePower.EGP < 0 ? 'red' : ''">
                          {{ clientData.purchasePower.EGP | currency : "EGP" }}
                        </span>
                        <span *ngIf="company.CURRENCY == 2 && clientData">
                          {{ clientData.purchasePower.USD | currency : "USD" }}
                        </span>
                      </div>
                    </div>
                  </div>
              
                  <div class="col-md-6 mb-1 px-1"
                    *ngIf="orderTotal > 0 ||  (isMarket && totalCost > 0)">
                    <div class="data-card">
                      <div class="data-title"
                        [ngClass]="{ 'text-left': translate.currentLang === 'en', 'text-right': translate.currentLang !== 'en' }">
                        {{ "order-value" | translate }}
                        <i class="bi bi-info-circle"></i>
                      </div>
                      <div class="data-value">
                        <span>
                          {{ orderTotal | number : "1.2-2" : "en-US" }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              
                <div class="row" *ngIf="orderTotal > 0 || (isMarket && totalCost > 0)">
                  <div class="col-md-6 mb-1 px-1">
                    <div class="data-card">
                      <div class="data-title">
                        {{ "order-fees" | translate }}
                        <i class="bi bi-info-circle"></i>
                      </div>
                      <div class="data-value">
                        <span>
                          {{ orderFees | number : "1.2-2" : "en-US" }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-1 px-1">
                    <div class="data-card">
                      <div class="data-title"
                        [ngClass]="{ 'text-left': translate.currentLang === 'en', 'text-right': translate.currentLang !== 'en' }">
                        {{ 'total-cost' | translate }}
                      </div>
                      <div class="data-value">
                        <span>
                          {{ totalCost | number: '1.2-2' : 'en-US' }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              

        <!-- // This is the part is end Order Data   -->


            <div *ngIf="((!isValidOrderCost && (inputUser!=null && orderTotal>0))&& !isLoading)"
              class="text-danger text-center">
              {{ 'order-value-exceeded-purchase' | translate }}
            </div>

            <ngb-accordion id="acc">
              <ngb-panel>
                <ng-template ngbPanelHeader let-opened="opened">
                  <div class="accordion-button custom-header" [class.collapsed]="!opened">
                    <button ngbPanelToggle class="p-0 btn container-fluid text-color-theme ps-0"
                      [ngClass]="{ disable:!clientData || clientData.length === 0}">

                      {{ "more" | translate }}
                    </button>
                  </div>
                </ng-template>

                <ng-template ngbPanelContent>
                  <div class="row">
                    <div class="col-md-6 text-start">
                      <h6>{{ "custodian" | translate }}</h6>
                      <select formControlName="custodian" name="custodian" class="form-control">
                        <option *ngFor="let acc of custodianList" value="{{ acc.CustodianCode }}">
                          {{ acc.CustodianNameE }}
                        </option>
                      </select>
                      <div *ngIf="f.custodian.touched && f.custodian.invalid" class="red">
                        <div *ngIf="f.custodian.errors?.required">
                          You must select custodian
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 mb-3 text-start">
                      <h6>{{ "exec-rule" | translate }}</h6>
                      <select formControlName="execRule" class="form-control">
                        <option value="0">Regular</option>
                        <option value="169">All or None</option>
                        <option value="150">MF</option>
                        <option value="163">FOK</option>
                        <option value="167">FAK</option>
                      </select>
                      <div *ngIf="f.execRule.touched && f.execRule.invalid" class="red">
                        <div *ngIf="f.execRule.errors?.required">
                          You must select exec rule
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 text-start" *ngIf="f.execRule.value == 150">
                      <label>{{ "min-fill-volume" | translate }}</label>
                      <input formControlName="minFillVolume"
                        oninput="if(!this.value.match('^[1-9][0-9]*$'))this.value='';" min="1" type="text"
                        class="form-control" required />
                    </div>

                    <div class="col-md-6 mb-3 text-start">
                      <h6>{{ "valid-till" | translate }}</h6>
                      <select formControlName="validTill" #validTill class="form-control"
                        [ngClass]="{'disable':userProfile?.OpenOrderRestriction}"
                        >
                          <option value="0">{{ "Today" | translate }}</option>
                          <option value="6" *ngIf="!userProfile?.OpenOrderRestriction">{{ "TillDate" | translate }}</option>
                          <option value="1" *ngIf="!userProfile?.OpenOrderRestriction">{{ "TillCancel" | translate }}</option>
                      </select>
                      <div class="openOrderRestriction-text" [ngClass]="{'hidden': !userProfile?.OpenOrderRestriction}">
                        {{
                          "openOrdersDisabled" | translate
                          }}
                      </div>
                      <!-- <div class="margin-text" [ngClass]="{'hidden': !inputUser.IsMargin}">
                        {{
                        translate.currentLang == "en"
                        ? "Margin clien cannot change validity"
                        : "لا يمكن لعملاء الهامش تغيير صلاحيتهم"
                        }}
                      </div> -->
                      <div *ngIf="f.validTill.touched && f.validTill.invalid" class="red">
                        <div *ngIf="f.validTill.errors?.required">
                          You must select valid till
                        </div>
                      </div>
                    </div>




                    <!-- <mat-form-field *ngIf="validTill.value == 6" class="col-md-6 " appearance="fill"
                      style="font-size: 12px !important; padding-top: 25px; ">
                      <mat-label>Choose a date</mat-label>
                      <input matInput [matDatepicker]="picker" formControlName="tiffDate">
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field> -->

                    <div class="col-6 text-start" *ngIf="validTill.value == 6">
                      <h6>{{ "select-date" | translate }}</h6>
                      <input (focus)="pickerFrom.open()" class="form-control" #date id="date" matInput name="tiffDate"
                        formControlName="tiffDate"   readonly [min]="minTiffDate" [matDatepicker]="pickerFrom" />
                      <!-- <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle> -->
                      <mat-datepicker #pickerFrom></mat-datepicker>
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>
            </ngb-accordion>
          </div>
        </form>
        <div >
          <button (click)="sendOrder(1)" [ngClass]="{ disabled:orderForm.invalid ||
           investmentData?.targetWeight * 100 < investmentData?.currentWeight ||
            (!this.brokerInfo?.IsAllowExceedPP && !isValidOrderCost) ||
            sendingOrder||isPriceInvalid() }" type="button" style="width: 100%; margin-bottom: 40px;" class="btn btn-success text-center">
            <span *ngIf="sendingOrder" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ "send-order" | translate }}
          </button>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="sell">{{ "sell" | translate }}</span>
    </ng-template>
    <div class="d-flex justify-content-between" id="dark" >
      <div class="market-trade-sell text-color-theme">
        <div class="container" *ngIf="!companyDetails">
          <div class="row" style="text-align: center;">
            <div class="col-md-12 mb-3" >
              <span class="text-muted" >
                <label > <br />
                  {{ "choose-company" | translate }}</label>
                  <i class="fa-solid fa-search mx-1 font-medium text-highlight-company-color clickable" (click)="selectCompany()" style="font-family: 'Font Awesome 6 Free' !important;"></i>
                </span>

            </div>
          </div>
        </div>
        <div class="stock-card">
          <div class="stock-left">
              <img [src]="UrlImage" alt="Stock Image for {{ company.SYMBOL_CODE }}" class="stock-logo">
              <i class="fa-solid fa-marker mx-1 font-medium text-highlight-company-color clickable " (click)="selectCompany()" ></i>
              <div class="stock-info">
                  <div class="text-start stock-title text-start">{{company.Reuters}}
                    <span *ngIf="company?.SYMBOL_STATE == 'S'" class="badge bg-danger text-light mx-1">
                      {{ "company-suspended" | translate }}
                    </span>
                  </div>
                  <div class="text-start  stock-subtitle">{{translate.currentLang == "en" ? company.ENG_NAME : company.ARB_NAME}}</div>
              </div>
          </div>
          <div class="stock-right">
            <div [ngClass]="{
              'pulse': company.LAST_TRADE_PRICE_UPDATED === 2,
              'pulse-up': company.LAST_TRADE_PRICE_UPDATED === 1,
              'no-change': company.LAST_TRADE_PRICE_UPDATED === 0
            }"
               class="stock-price">{{company.LAST_TRADE_PRICE | number : "1.0" : "en-US"}} <span class="currency">{{
                          company.CURRENCY == 1 
                            ? (translate.currentLang === 'en' ? 'EGP' : 'جنيه مصرى')
                            : company.CURRENCY == 2 
                            ? (translate.currentLang === 'en' ? 'USD' : 'دولار امريكى')
                            : ''
                        }}</span></div>
              <div [ngClass]="{
                'pulse': company.LAST_CHANGE_PRC_UPDATED === 2,
                'pulse-up': company.LAST_CHANGE_PRC_UPDATED === 1,
                'no-change': company.LAST_CHANGE_PRC_UPDATED === 0,
                'green':company.LAST_CHANGE_PRC > 0,
                'red':company.LAST_CHANGE_PRC < 0
              }"  
              [ngClass]="company.LAST_CHANGE_PRC > 0 ? 'green' : 'red'"  class="stock-change">{{ company.LAST_CHANGE | number : "1.0" : "en-US" }} ({{company.LAST_CHANGE_PRC | number : "1.0" : "en-US"}}%) <span class="arrow">&#8593;</span></div>
          </div>
      </div>
      <div class="ticket-sell" *ngIf="companyDetails">
        <div class="ticket-content">
          <div class="row">
            <div class="column">
              <div class="label">{{ "best-bid" | translate }} </div>
              <div class="value">         
                <span class="scalable" [ngClass]="{
                  'pulse': company.BID_PRICE_UPDATED === 2,
                  'pulse-up': company.BID_PRICE_UPDATED === 1,
                  'no-change': company.BID_PRICE_UPDATED === 0
                }"
                >{{ company.BID_PRICE | number : "1.0" : "en-US" }}</span> /
                <span class="scalable"
                [ngClass]="{
                  'pulse': company.BID_VOLUME_UPDATED === 2,
                  'pulse-up': company.BID_VOLUME_UPDATED === 1,
                  'no-change': company.BID_VOLUME_UPDATED === 0
                }"
                >{{ company.BID_VOLUME | number : "1.0" : "en-US" }}</span></div>
            </div>
            <div class="column">
              <div class="label"> {{ "best-ask" | translate }}</div>
              <div class="value">            
                <span class="scalable"
                [ngClass]="{
                  'pulse': company.ASK_PRICE_UPDATED === 2,
                  'pulse-up': company.ASK_PRICE_UPDATED === 1,
                  'no-change': company.ASK_PRICE_UPDATED === 0
                }"
                >{{ company.ASK_PRICE | number : "1.0" : "en-US" }}</span> /
                <span class="scalable"
                [ngClass]="{
                  'pulse': company.ASK_VOLUME_UPDATED === 2,
                  'pulse-up': company.ASK_VOLUME_UPDATED === 1,
                  'no-change': company.ASK_VOLUME_UPDATED === 0
                }"
                >{{ company.ASK_VOLUME | number : "1.0" : "en-US" }}</span></div>
            </div>
            <div class="column">
              <div class="d-flex flex-column align-items-center">
                    <!-- First Row: Text & Hint Popover (Side by Side) -->
                    <div class="d-flex align-items-center">
                      <span class="me-2">           
                      {{ "Margin"|translate }}
                      </span>
                
                      <hint-popover *ngIf="companyDetails?.ISMarginable != null && companyDetails?.ISMarginable != false"
                        [key]="'ISMarginable'" [value]="companyDetails?.MarginPercentage" [placement]="translate.currentLang == 'ar' ? 'right' : 'left'"></hint-popover>
                      <hint-popover *ngIf="companyDetails?.ISMarginable == null || companyDetails?.ISMarginable == false"
                        [key]="'ISNotMarginable'" [placement]="translate.currentLang == 'ar' ? 'right' : 'left'"></hint-popover>
        
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="ms-2">
                        <path
                          d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                      </svg>
                    </div>
                    <!-- IsMargin with Green Check -->
                  <div *ngIf="(companyDetails?.ISMarginable != null && companyDetails?.ISMarginable != false) && (isCustodianSymbolMarginAvailable || !inputUser?.IsMargin)"
                    class="d-flex align-items-center me-2">
                    <span class="check-mark-icon">
                      <svg class="svg-green"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path
                          d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z">
                        </path>
                      </svg>
                    </span>
                  </div>
      
                  <!-- IsMargin with Red Cross -->
                  <div *ngIf="(companyDetails?.ISMarginable == null || companyDetails?.ISMarginable == false) || (!isCustodianSymbolMarginAvailable && inputUser?.IsMargin && companyDetails?.ISMarginable)"
                    class="d-flex align-items-center me-2">
                    <span class="check-mark-icon">
                      <svg class="svg-red" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path
                          d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z">
                        </path>
                      </svg>
                    </span>
                  </div>
                  </div>
            </div>
            
          </div>
      
          <hr class="divider" />
      
          <div class="row">
            <div class="column">
              <p class="label"> {{ "max-limit" | translate }} </p>
              <p class="value">{{ companyDetails?.MaxLimit }}</p>
            </div>
            <div class="column">
              <p class="label">{{ "min-limit" | translate }}</p>
              <p class="value"> {{ companyDetails?.MinLimit }}</p>
            </div>
            <div class="column">
              <div class="d-flex flex-column align-items-center">
                <!-- First Row: Text & Hint Popover (Side by Side) -->
                <div class="d-flex align-items-center">
                  <span class="me-2">{{ "T+0 " }}</span>
            
                  <hint-popover *ngIf="companyDetails?.SameDayQty != null && companyDetails?.SameDayQty != 0"
                    [key]="'T0-enabled'" [placement]="translate.currentLang == 'ar' ? 'right' : 'left'">
                  </hint-popover>
            
                  <hint-popover *ngIf="companyDetails?.SameDayQty == null || companyDetails?.SameDayQty == 0"
                    [key]="'T0-disabled'" [placement]="translate.currentLang == 'ar' ? 'right' : 'left'">
                  </hint-popover>
                </div>
            
                <!-- Second Row: Check Mark -->
                <div class="d-flex justify-content-center">
                  <span class="check-mark-icon">
                    <svg *ngIf="companyDetails?.SameDayQty != null && companyDetails?.SameDayQty != 0" class="svg-green"
                      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                      <path
                        d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z">
                      </path>
                    </svg>
            
                    <svg *ngIf="companyDetails?.SameDayQty == null || companyDetails?.SameDayQty == 0" class="svg-red"
                      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                      <path
                        d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z">
                      </path>
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

        <hr style="background: #6c757d !important ; margin: 5px;" />

        <form [formGroup]="orderForm">
          <div class="form-group">
            <div class="row">
              <div class="col-md-12" style="margin-bottom: 1vh !important;">
                <h6 class="text-start text-color-theme">
                  {{ "choose-account" | translate }}
                </h6>
                <div class="col-10 p-0">
                  <ng-select class="custom" appearance="outline" [clearable]="false" (change)="onSelectClient($event)" [searchable]="false" formControlName="client">
                    <ng-option *ngFor="let acc of accList" value="{{acc.relationCode}}">
                      ({{acc.relationCode}}) {{translate.currentLang=='en'?acc.clientNameEn:acc.clientNameAr}}
                    </ng-option>
                  </ng-select>
                  <div *ngIf="f.client.touched && f.client.invalid" class="red">
                    <div *ngIf="f.client.errors?.required">You must select client</div>
                  </div>

                </div>
                <user-selection *ngIf="tabIndex == 0" [inputUser]="inputUser" [isBindValue]="true"
                  (userChanged)="onSelectClient($event)"></user-selection>
                <section *ngIf="isFetchingUserData">
                  <mat-progress-bar class="example-margin" [color]="'primary'" [mode]="'indeterminate'" [value]="50"
                    [bufferValue]="75">
                  </mat-progress-bar>
                </section>

                <div *ngIf="f.client.touched && f.client.invalid" class="red">
                  <div *ngIf="f.client.errors?.required">
                    You must select client
                  </div>
                </div>
              </div>

            </div>
            <div class="col-md-12 mb-3">
              <mat-button-toggle-group (change)="toggleStopLoss($event)" class="toggle-group-border"
                style="width: 100%; border-radius: 5px" appearance="legacy" value="cashOrqty">
                <mat-button-toggle style="width: 50%" value="cashOrqty">{{
                  "cash-qty" | translate
                  }}</mat-button-toggle>
                <mat-button-toggle style="width: 50%" value="stopLoss">{{
                  "stop-loss" | translate
                  }}</mat-button-toggle>
              </mat-button-toggle-group>
            </div>

           <div class="sell-options" *ngIf="AvbSetteled != 0 || AvbTPlusOne != 0 || AvbTPlusZero != 0 || inputUser ">
                    <div class="option" (click)="clickedS()" 
                      [ngClass]="{
                        disabled: AvbSetteled == 0,
                        active: sellType == 2,
                        settled: sellType == 2
                      }"
                    >
                      <span class="title">{{'settled' | translate}}</span>
                      <span class="value" (click)="qtyClickedS()" >{{AvbSetteled}}</span>
                    </div>
                    <div class="option" (click)="clickedT1()" [ngClass]="{disabled: AvbTPlusOne == 0,active: sellType == 5}">
                      <span class="title">T+1</span>
                      <span class="value" (click)="qtyClickedT1()">{{AvbTPlusOne}}</span>
                    </div>
                    <div class="option" (click)="clickedT0()" [ngClass]="{disabled: AvbTPlusZero == 0,active: sellType == 3}">
                      <span class="title">T+0</span>
                      <span class="value" (click)="qtyClickedT0()">{{AvbTPlusZero}}</span>
                    </div>
                  </div>

            <div class="col-md-12 mt-3" *ngIf="(allowStopLoss && isStopLoss) || !isStopLoss">
              <mat-button-toggle-group (change)="toggle($event)" class="toggle-group-border"
                style="width: 100%; border-radius: 5px" appearance="legacy" value="limit">
                <mat-button-toggle style="width: 50%" value="limit">{{
                  "limit-price" | translate
                  }}</mat-button-toggle>
                <mat-button-toggle style="width: 50%" value="market">{{
                  "market-price" | translate
                  }}</mat-button-toggle>
              </mat-button-toggle-group>
            </div>

            <div class="row mt-4 mb-2" *ngIf="(allowStopLoss && isStopLoss) || !isStopLoss">
              <div class="col-md-6">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="border-radius: 5px">{{
                      "qty" | translate
                      }}</span>
                  </div>
                  <input style="border-radius: 5px" min="1"
                    oninput="if(!this.value.match('^[1-9][0-9]*$'))this.value='';" (keypress)="numberOnly($event)"
                    formControlName="qty" type="text" class="form-control" [ngClass]="
                      translate.currentLang == 'en'
                        ? 'number-input'
                        : 'number-input-ar'
                    " />
                </div>
              </div>

              <div class="col-md-6" [ngClass]="{ hidden: isMarket  }">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="border-radius: 5px">
                      {{ "price" | translate }}
                    </span>
                  </div>
                  <input style="border-radius: 5px; text-align: center" min="1" (keypress)="priceDecimalInput($event)"
                    formControlName="price" type="text" class="form-control" [ngClass]="
                      translate.currentLang == 'en' ? 'number-input' : 'number-input-ar'
                    " />
                </div>
              </div>
              <div class="col-md-6" [ngClass]="{ hidden: !isMarket || isStopLoss }">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="border-radius: 5px">
                      {{ "MKT" | translate }}
                    </span>
                  </div>

                </div>
              </div>
            </div>
            <div class="container mt-3 mb-3" *ngIf="(!allowStopLoss && isStopLoss)">
              <div class="row" style="text-align: center;">
                <div class="col-md-12 mb-3 mt-2" >
                  <span class="text-muted" >
                    <label > <br />
                      {{ "allow-StopLoss" | translate }}</label>
                  </span>
    
                </div>
              </div>
                  </div>  

            <div class="container" *ngIf="!clientData">
              <div class="row" style="text-align: center;">
                <div class="col-md-12 mb-3" >
                  <span class="text-muted" >
                    <label > <br />
                      {{ "choose-account" | translate }}</label>
                  </span>
    
                </div>
              </div>
              
                  </div>    
                             
            <div class="container" *ngIf="clientData">
              <div class="row">
                <div class="col-md-6 mb-1 px-1"
                  [@expandCard]="purchasePowerState"
                  class="purchase-power-card px-1 col-md-6">
                  <div class="data-card">
                    <div class="data-title">
                      {{ "available-stocks" | translate }}
                    </div>
                    <div class="data-value">
                      <span [ngClass]="AvbSetteled == 0 ? 'red' : ''"  *ngIf="sellType == 2" >{{AvbSetteled}}</span>
                      <span [ngClass]="AvbTPlusZero == 0 ? 'red' : ''" *ngIf="sellType == 3" >{{AvbTPlusZero}}</span>
                      <span [ngClass]="AvbTPlusOne == 0 ? 'red' : ''" *ngIf="sellType == 5" >{{AvbTPlusOne}}</span>

                    </div>
                  </div>
                </div>
            
                <div class="col-md-6 mb-1 px-1"
                  *ngIf="orderTotal > 0 ||  (isMarket && totalCost > 0)">
                  <div class="data-card">
                    <div class="data-title"
                      [ngClass]="{ 'text-left': translate.currentLang === 'en', 'text-right': translate.currentLang !== 'en' }">
                      {{ "order-value" | translate }}
                      <i class="bi bi-info-circle"></i>
                    </div>
                    <div class="data-value">
                      <span>
                        {{ orderTotal | number : "1.2-2" : "en-US" }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            
              <div class="row" *ngIf="orderTotal > 0 || (isMarket && totalCost > 0)">
                <div class="col-md-6 mb-1 px-1">
                  <div class="data-card">
                    <div class="data-title">
                      {{ "order-fees" | translate }}
                      <i class="bi bi-info-circle"></i>
                    </div>
                    <div class="data-value">
                      <span>
                        {{ orderFees | number : "1.2-2" : "en-US" }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-1 px-1">
                  <div class="data-card">
                    <div class="data-title"
                      [ngClass]="{ 'text-left': translate.currentLang === 'en', 'text-right': translate.currentLang !== 'en' }">
                      {{ 'total-cost' | translate }}
                    </div>
                    <div class="data-value">
                      <span>
                        {{ totalCost | number: '1.2-2' : 'en-US' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-danger text-center" [ngClass]="{'hidden': !exceedSettledSellAmountAlert}">
                    {{
                    "ExceedSettledSellAmount" | translate
                    }}
                </div>
            </div>

            <ngb-accordion id="acc">
              <ngb-panel>
                <ng-template ngbPanelHeader let-opened="opened">
                  <div class="accordion-button custom-header" [class.collapsed]="!opened">
                    <button ngbPanelToggle class="p-0 btn container-fluid ps-0 text-color-theme">
                      {{ "more" | translate }}
                    </button>
                  </div>
                </ng-template>

                <ng-template ngbPanelContent>
                  <div class="row">
                    <div class="col-md-6 text-start">
                      <h6>{{ "custodian" | translate }}</h6>
                      <select formControlName="custodian" name="custodian" class="form-control" (change)="onselectedCustodian($event)">
                        <option *ngFor="let acc of custodianList" value="{{ acc.CustodianCode }}" >
                          {{ translate.currentLang === 'en' ? acc.CustodianNameE : acc.CustodianNameA }}
                        </option>
                      </select>
                      <div *ngIf="f.custodian.touched && f.custodian.invalid" class="red">
                        <div *ngIf="f.custodian.errors?.required">
                          You must select custodian
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 mb-3 text-start">
                      <h6>{{ "exec-rule" | translate }}</h6>
                      <select formControlName="execRule" class="form-control">
                        <option value="0">Regular</option>
                        <option value="169">All or None</option>
                        <option value="150">MF</option>
                        <option value="163">FOK</option>
                        <option value="167">FAK</option>
                      </select>
                      <div *ngIf="f.execRule.touched && f.execRule.invalid" class="red">
                        <div *ngIf="f.execRule.errors?.required">
                          You must select exec rule
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 text-start" *ngIf="f.execRule.value == 150">
                      <label>{{ "min-fill-volume" | translate }}</label>
                      <input formControlName="minFillVolume"
                        oninput="if(!this.value.match('^[1-9][0-9]*$'))this.value='';" min="1" type="text"
                        class="form-control" required />
                    </div>

                    <div class="col-md-6 text-start">
                      <h6>{{ "valid-till" | translate }}</h6>
                      <select [ngClass]="{disabled:sellType!=2}" formControlName="validTill" #validTill
                        class="form-control">
                        <option value="0">{{ "Today" | translate }}</option>
                        <option *ngIf="sellType==2" value="6">{{ "TillDate" | translate }}</option>
                        <option *ngIf="sellType==2" value="1">{{ "TillCancel" | translate }}</option>
                      </select>
                      <div *ngIf="f.validTill.touched && f.validTill.invalid" class="red">
                        <div *ngIf="f.validTill.errors?.required">
                          You must select valid till
                        </div>
                      </div>
                    </div>


                    <mat-form-field *ngIf="validTill.value == 6" class="col-md-6" appearance="fill"
                      style="font-size: 12px !important; padding-top: 25px">
                      <mat-label>Choose a date</mat-label>
                      <input matInput [matDatepicker]="picker" (keypress)="$event.preventDefault()"  [min]="minTiffDate"  formControlName="tiffDate" />
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </ng-template>
              </ngb-panel>
            </ngb-accordion>
          </div>
        </form>
        <div>
          <button (click)="sendOrder(2)" [disabled]="isPriceInvalid() ||orderForm.invalid 
          || (!isMarket && orderTotal==0)||exceedSettledSellAmountAlert 
          ||sellType == 0" type="button" style="width: 100%; margin-bottom: 40px;" class="btn btn-danger text-center">
            <span *ngIf="sendingOrder" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ "send-order" | translate }}
          </button>
        </div>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
</div>

<div id="dark" class="d-flex justify-content-center" *ngIf="!company">
  <div class="spinner-border text-secondary m-5" role="status">
    <span class="sr-only"></span>
  </div>
</div>